export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Ich hatte schreckliche Angst vor der Schulterrehabilitation. Die Phasen und Kriterien wirkten unmöglich. Nach Tag 5 mit DER REHA-CODE 360° konnte ich mein erstes Protokoll ohne Hilfe strukturieren. In Woche 3 coachte ich bereits CrossFit-Athleten sicher beim Bankdrücken mit dem Traffic Light System.',
    name: 'Marcus T.',
    location: 'Berlin · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/80848e14-15f4-430a-9b92-68ab90c6b61e.jpg',
  },
  {
    quote:
      'Nach 6 Monaten Online-Kursen war ich immer noch verloren. DER REHA-CODE 360° funktioniert wirklich. Mit dem Load Master Protocol weiß ich jetzt genau, wann meine Athleten bereit sind, die Last zu erhöhen.',
    name: 'Sofia L.',
    location: 'Wien · Österreich',
    flag: '🇦🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/362d210d-32c8-42e9-94ff-bc4f4952fd79.jpg',
  },
  {
    quote:
      'Ich fürchtete, ich sei nicht „gut genug" für komplexe Verletzungen. DER REHA-CODE 360° hat mich vom Gegenteil überzeugt. Das A.R.M.A. Präventions-Schild hält meine Athleten von Verletzungen ab. Ich empfehle es jedem Trainer und Therapeuten.',
    name: 'David P.',
    location: 'Zürich · Schweiz',
    flag: '🇨🇭',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47b0264e-cbb6-45c9-bff8-6a1a4a2fd195.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Das Traffic Light System revolutionierte meine Praxis. Keine Vermutungen mehr. Grün = voranschreiten, Gelb = vorsichtig, Rot = stopp. Meine Athleten verstehen ihre Progression jetzt. Ich betreue 8 Athleten mit echtem Selbstvertrauen.',
    name: 'James R.',
    location: 'München · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7403b0e6-4b72-48c1-9192-410f031e00ab.jpg',
  },
  {
    quote:
      'Nach 6 Monaten YouTube-Protokolle war ich völlig verloren. Jetzt habe ich einen klaren, wissenschaftlichen Weg. Klienten heilen schneller.',
    name: 'Emma T.',
    location: 'Hamburg · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/81425cb1-d010-4002-b9db-3ff420402612.jpg',
  },
  {
    quote:
      'Das Load Master Protocol ist Brillanz. Ich rechne Gewicht & Reps aus, der Athlet führt aus, ich tracke die Daten. In Woche 4 hatte ich meinen ersten Athleten sicher beim schweren Heben zurück.',
    name: 'Luis M.',
    location: 'Köln · Deutschland',
    flag: '🇩🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/880ec9f6-323a-450b-80d1-71b8a76c1a33.jpg',
  },
  {
    quote:
      'Ich kaufte es für die Schulterprotokolle und blieb wegen des A.R.M.A. Systems. Meine Athleten haben jetzt eine Lebenszeit-Wartungsroutine. Keine Rückfälle mehr.',
    name: 'Rachel P.',
    location: 'Wien · Österreich',
    flag: '🇦🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fe614a6f-eaed-43fd-ab74-bd42110ca59c.jpg',
  },
];
